import rgba from 'polished/lib/color/rgba';
import rem from 'polished/lib/helpers/rem';
import { colors } from '@omilia/theme';

export const floatingUi = `
div[data-floating-ui-focusable] {
  background-color: ${rgba(colors.COLOR_GREY_1000, 0.72)};
  border-radius: 3px;
  color: white;
  font-family: 'Montserrat, sans-serif';
  font-size: ${rem('12px')};
  font-weight: 400;
  max-width: 500px;
  overflow-wrap: break-word;
  padding: 4px 8px;
  width: max-content;
  z-index: 9999;
}
`;
